import type { ComboBoxOption } from '../types/ComboBoxOption';

export const getSelectedOptions = <Option extends ComboBoxOption>({
    value,
    options,
    selectedOptions,
}: {
    value: Array<Option['value']>;
    options: Option[];
    selectedOptions: Option[];
}): Option[] => {
    const selectedValueSet = new Set(value);
    const optionByValue = new Map<Option['value'], Option>();

    [...selectedOptions, ...options].forEach((option) => {
        optionByValue.set(option.value, option);
    });

    return Array.from(selectedValueSet)
        .map((selectedValue) => optionByValue.get(selectedValue))
        .filter((option): option is Option => !!option);
};
